
export default {
  name: "TimePicker",
  props: {
    cart: {
      type: [Object, Boolean],
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    fixed: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: () => ({
    showTimes: false,
    chosenTime: false,
  }),
  computed: {
    hasWindows() {
      return this.cart?.date?.deliveryWindows?.length > 0
    },
    hasSelected() {
      return this.cart.date?.selectedWindow
    },
    hasDate() {
      return this.cart.date
    },
    times() {
      const windows = this.cart?.date?.deliveryWindows || []

      if (!windows.length) return []
      const times = windows.map((w) => this.$moment(w.name, "HH:mm"))
      const start = this.$moment.min(times)
      const end = this.$moment.max(times).clone().add(30, "minutes") // Add 30 mins so last window shows properly

      const intervals = []
      const current = start.clone()

      while (current.clone().add(30, "minutes").isSameOrBefore(end)) {
        const next = current.clone().add(30, "minutes")
        intervals.push(`${current.format("HH:mm")} - ${next.format("HH:mm")}`)
        current.add(15, "minutes")
      }

      return intervals
    },
  },
  methods: {
    toggleTimes() {
      this.showTimes = !this.showTimes
    },
    returnTime() {
      const time = `${this.chosenTime.slice(8, this.chosenTime.length)}`
      this.showTimes = false
      this.$emit("returnTime", time)
    },
  },
}
